import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

import { StoreModule } from '@ngrx/store';
import { MomentModule } from 'ngx-moment';
import { EffectsModule } from '@ngrx/effects';
import { TranslateModule } from '@ngx-translate/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import * as fromProofOfDelivery from './+state/proof-of-delivery.reducer';
import { ProofOfDeliveryFacade } from './+state/proof-of-delivery.facade';
import { ProofOfDeliveryEffects } from './+state/proof-of-delivery.effects';
import { ProofOfDeliveryViewComponent } from './components/proof-of-delivery-view/proof-of-delivery-view.component';

@NgModule({
    imports: [
        CommonModule,
        MomentModule,
        RouterModule,
        TranslateModule,
        FontAwesomeModule,
        StoreModule.forFeature(
            fromProofOfDelivery.PROOF_OF_DELIVERY_FEATURE_KEY,
            fromProofOfDelivery.reducer
        ),
        EffectsModule.forFeature([ProofOfDeliveryEffects]),
    ],
    declarations: [ProofOfDeliveryViewComponent],
    exports: [ProofOfDeliveryViewComponent],
    providers: [ProofOfDeliveryFacade],
})
export class PortalsProofOfDeliveryModule {}
